import * as actions from 'actions/eventFilters';

export const defaultState = {
  loading: false,
  error: false,
  data: [],
  selectedRows: {},
  sortBy: 'FILTER_NAME',
  sortOrder: 'ASCENDING',
};

export default function eventFilters(state = defaultState, action) {
  switch (action.type) {
    case actions.LOAD_START:
      return {
        ...state,
        loading: true,
        error: false,
        data: [],
        selectedRows: {},
        ...action.payload,
      };
    case actions.LOAD_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case actions.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        total: action.payload.total,
        links: action.payload.links,
        data: action.payload.data,
      };
    case actions.LOAD_MORE_START:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case actions.LOAD_MORE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        links: action.payload.links,
        data: state.data.concat(action.payload.data),
      };
    case actions.LOAD_MORE_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case actions.SELECT_ROW:
      return {
        ...state,
        selectedRows: {
          ...state.selectedRows,
          [action.payload.id]: !state.selectedRows[action.payload.id],
        },
      };
    case actions.UNSELECT_ROWS:
      return {
        ...state,
        selectedRows: {},
      };
    case actions.DELETE_FILTERS_SUCCESS:
      return {
        ...state,
        selectedRows: {},
      };
    case actions.TOGGLE_ENABLE_DISABLE_SUCCESS: {
      const index = state.data
        .map(filter => filter.id)
        .indexOf(action.payload.id);

      return {
        ...state,
        data: state.data.map((filter, idx) => {
          if (idx !== index) return filter;
          return action.payload;
        }),
      };
    }
    default:
      return state;
  }
}
